import React from 'react';
import Media from "components/elements/Media";
import Paragraph from "components/elements/Paragraph";
import Section from "components/elements/Section";
import useForm from "components/hooks/useForm";
import { IMedia } from "types/base";
import { ITextBlock } from "blocks/text/TextBlock";

export type IFormBlock = {
    id: string,
    hubspotFormId: string,
    disclaimer?: string,
    media?: IMedia[],
    content?: ITextBlock[],
};

type Props = {
    slug: string;
};

export default function Form(props: Props & IFormBlock) {
    const { isReady } = useForm({
        formId: props.hubspotFormId,
        slug: props.slug
    });

    return (
        <Section
            className={"flex flex-col lg:flex-1 lg:rounded-2xl lg:bg-purple-tint-lighter lg:p-10 align-middle transition-all ease-in-out duration-300"}
        >
            {props.media && props.media.map((media, i) => (
                <Media key={i + "media-on-form"} {...media} className={"my-10"} />
            ))}

            <div className={"hubspot-form-block"} />

            {props.disclaimer && (
                <Paragraph
                    size={'extra-small'}
                    fontWeight={'light'}
                    className={'text-purple-tint-dark text-center mx-auto mt-6'}
                >
                    {props.disclaimer}
                </Paragraph>
            )}
        </Section>
    );
}